  export const firebaseConfig = {
    apiKey: "AIzaSyBAU6iMmJ4WDe-Wx9uprjLzoPdXcMmWRQs",
    authDomain: "balwin-60c4a.firebaseapp.com",
    databaseURL: "https://balwin-60c4a.firebaseio.com",
    projectId: "balwin-60c4a",
    storageBucket: "balwin-60c4a.appspot.com",
    messagingSenderId: "979073331117",
    appId: "1:979073331117:web:57285af768442cd6"
  };